// import React, { useEffect, useState } from "react";
// import TextField from "@mui/material/TextField";
// import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
// import Navbar from "../Navbar";
// import "react-toastify/dist/ReactToastify.css";
// import { ToastContainer, toast } from "react-toastify";
// import FormControl from "@mui/material/FormControl";
// import ListItemText from "@mui/material/ListItemText";
// import Select from "@mui/material/Select";
// import Checkbox from "@mui/material/Checkbox";
// // import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";
// import axios from "axios";
// import { Link } from "react-router-dom";
// import { useDispatch } from "react-redux";
// import { Formik, useFormik } from "formik";

// import { createTheme, ThemeProvider } from "@mui/material/styles";
// // import ChooseFile from "./ChooseFile";
// import { withRouter } from "react-router-dom";
// // import Blacklist from "./BlackList";
// // import Blacklist from "../Blacklisting/Blacklist";
// import Blacklist from "../Blacklisting/Blacklist";
// // import Whitelist from "./Whitelist";
// import BulkUpload from "../WhiteListing/BulkUpload";
// import AddContact from "./AddContact";
// import AddNewList from "./AddNewList";
// import ImportContact from "./ImportContact";
// // import CallIcon from '@mui/icons-material/Call';
// import ContactsSharpIcon from "@mui/icons-material/ContactsSharp";
// import Swal from "sweetalert2";
// import { common_axios } from "../../../App";
// import ExportContact2 from "./ExportContact2";
// import DownloadExportData from "./DownloadExportData";
// // import NumberList from "../WhiteListing/NumberList";
// function MainWhitelisting() {
//   const theme = createTheme({
//     components: {
//       MuiInputLabel: {
//         styleOverrides: {
//           asterisk: { color: "red" },
//           // "&$error": {
//           //   color: "#db3131",
//           // },
//         },
//       },
//     },
//   });

//   const [MenuItemPhoneBook, setMenuItemPhoneBook] = useState(undefined);
//   const [open, setOpen] = useState(false);
//   const [data, setData] = useState([]);
//   // console.log("data--", Namedata);
//   const [TableStatus, setTableStatus] = useState({
//     hideShow: false,
//     pageNo: 0,
//     pageSize: 10,
//   });

//   // ...............................DownloadTab API Redirect................................................//
//   const [downloadData, setDownloadData] = useState([]);
// console.log("fffirst",downloadData)
//   async function DownloadTabApi() {
//     try {
//       // setHideSkeleton(true)
//       if(MenuItemPhoneBook == 0 ){
//         const result = await common_axios.post(
//           `${process.env.REACT_APP_COMMON_API_PHONEBOOKCONTACTS}/user/v2/get/phonebook/download/report`,
//           // {
//           //   pageNo: Status?.pageNo,
//           //   pageSize: Status?.pageSize,
//           // }
  
//           {
//             downloadReportRequest: {
//                 reportType:"phonebook",
//                 pageNo: TableStatus?.pageNo,
//                 pageSize: TableStatus?.pageSize,
//             }
//         }
//         );
//         if (result.data.statusdescription.statusCode == 200) {
//           // alert("enter")
//           // DownloadTabApi()
//           setDownloadData(result?.data?.downloadReport);

//           setOpen(false);
       
//         } else {
//           // setData([])
  
//           setOpen(false);
  
//           Swal.fire({
//             icon: "error",
//             title: "Oops...",
//             text: result.data.statusdescription.statusDescription,
//             // footer: '<a href="">Why do I have this issue?</a>'
//           });
//         }
//       }
//      else{
//       const result = await common_axios.post(
//         `${process.env.REACT_APP_COMMON_API_PHONEBOOKCONTACTS}/user/v2/get/phonebook/download/report`,
//         // {
//         //   pageNo: Status?.pageNo,
//         //   pageSize: Status?.pageSize,
//         // }

//         {
//           downloadReportRequest: {
//               reportType:"Bulk group",
//               pageNo: TableStatus?.pageNo,
//               pageSize: TableStatus?.pageSize,
//           }
//       }
//       );
//       if (result.data.statusdescription.statusCode == 200) {
//         // DownloadTabApi()
     
//         setOpen(false);
//         // const butt = document.getElementById("Download-tab");
//         // butt.click();
//       } else {
//         // setData([])
//         setDownloadData(result?.data?.downloadReport);
  
//         setOpen(false);
  
//         Swal.fire({
//           icon: "error",
//           title: "Oops...",
//           text: result.data.statusdescription.statusDescription,
//           // footer: '<a href="">Why do I have this issue?</a>'
//         });
//       }
//      }
     
//     } catch (error) {
//       setOpen(false);
//       // toast.error("Please Check Your Network",{
//       //   toastId: customId1,
//       //   theme: "colored",
//       // });
//       Swal.fire({
//         icon: "error",
//          title: "Oops...",
//         text:"Please Check Your Network",
//         // footer: '<a href="">Why do I have this issue?</a>'
//       });
//     }
//   }










//   return (
//     <>
//       <main className="main-content position-relative border-radius-lg ">
//         {/* <Backdrop
//           sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
//           open={viewOpen}

//           // onClick={handleClose}
//         >
//           <LoadingSpinner />
//         </Backdrop> */}

//         <div className="container-fluid">
//           <div className="row">
//             <div className="col-xl-12 col-sm-12 mb-xl-0 mb-4">
//               <div className="card mb-3">
//                 <div className="card-header p-3 pt-2">
//                   <div className="icon icon-lg icon-shape bg-gradient-primary shadow-primary text-center border-radius-xl mt-n4 position-absolute">
//                     <ContactsSharpIcon className="ttl_icon" />
//                   </div>
//                   <div class="pt-1 marginleft_0">
//                     <p class="text-sm mb-0 text-capitalize fw-bold">CONTACT</p>
//                     <p className="text-sm mb-0  text d-inline-block float-end">
//                       Field(s) marked with{" "}
//                       <span className="text-danger fw-bold">*</span> are
//                       mandatory.
//                     </p>
//                   </div>
//                   <div className="text-end pt-1">
//                     {/* <p className="text-sm mb-0 text-capitalize fw-bold">
//                       Account Data Added, Please Provide Sender Masking Details
//                       !! Field(s) marked with{" "}
//                       <span className="text-danger fw-bold">*</span> are
//                       mandatory.
//                     </p> */}
//                   </div>
//                 </div>
//                 <div className="card-body">
//                   <ul className="nav nav-tabs" id="myTab" role="tablist">
//                     <li className="nav-item  list_1" role="presentation">
//                       <button
//                         className="nav-link active"
//                         id="home-tab"
//                         data-bs-toggle="tab"
//                         data-bs-target="#AccountDetails"
//                         type="button"
//                         role="tab"
//                         aria-controls="AccountDetails"
//                         aria-selected="true"
//                       >
//                         {/* MSISDN */}
//                         {/* Mobile Number */}
//                         Add Contact
//                       </button>
//                     </li>
//                     <li className="nav-item  list_1" role="presentation">
//                       <button
//                         className="nav-link ms-2"
//                         id="SenderMasking-tab"
//                         data-bs-toggle="tab"
//                         data-bs-target="#SenderMasking"
//                         type="button"
//                         role="tab"
//                         aria-controls="SenderMasking"
//                         aria-selected="false"
//                         // onClick={senderMasking}
//                         // disabled
//                       >
//                         {/* Choose File */}
//                         View Contact
//                       </button>
//                     </li>
//                     <li className="nav-item list_1" role="presentation">
//                       <button
//                         className="nav-link ms-2"
//                         id="ContactDetails-tab"
//                         data-bs-toggle="tab"
//                         data-bs-target="#ContactDetails"
//                         type="button"
//                         role="tab"
//                         aria-controls="ContactDetails"
//                         aria-selected="false"
//                         // onClick={fetchContactDetails}
//                       >
//                         Bulk Upload
//                       </button>
//                     </li>
//                     <li className="nav-item  list_1" role="presentation">
//                       <button
//                         className="nav-link ms-2"
//                         id="ExportContact-tab"
//                         data-bs-toggle="tab"
//                         data-bs-target="#ExportContact"
//                         type="button"
//                         role="tab"
//                         aria-controls="ExportContact"
//                         aria-selected="false"
//                         // onClick={senderMasking}
//                         // disabled
//                       >
//                         {/* Choose File */}
//                         Export Contact
//                       </button>
//                     </li>
//                     <li>
//                     <button
//                   className="nav-link ms-2 position-relative"
//                   id="Download-tab"
//                   data-bs-toggle="tab"
//                   data-bs-target="#DownloadDetails"
//                   type="button"
//                   role="tab"
//                   aria-controls="DownloadDetails"
//                   aria-selected="true"
//                   onClick={DownloadTabApi}
//                 >
//                   Download Report
                 
//                 </button>
//               </li>
//                   </ul>
//                   <div className="tab-content" id="myTabContent">
//                     <div
//                       className="tab-pane fade show active"
//                       id="AccountDetails"
//                       role="tabpanel"
//                       aria-labelledby="AccountDetails-tab"
//                     >
//                       <div>
//                         <AddContact />
//                       </div>
//                     </div>

//                     <div
//                       className="tab-pane fade"
//                       id="SenderMasking"
//                       role="tabpanel"
//                       aria-labelledby="SenderMasking-tab"
//                     >
//                       <AddNewList />{" "}
//                     </div>
//                     <div
//                       className="tab-pane fade "
//                       id="ContactDetails"
//                       role="tabpanel"
//                       aria-labelledby="AccountDetails-tab"
//                     >
//                       {/* <NumberList /> */}
//                       <ImportContact />
//                     </div>
//                     <div
//                       className="tab-pane fade "
//                       id="ExportContact"
//                       role="tabpanel"
//                       aria-labelledby="ExportContact-tab"
//                     >
//                       {/* <ExportContact /> */}
//                       <ExportContact2 />
//                     </div>
//                     <div
//                       className="tab-pane fade "
//                       id="DownloadDetails"
//                       role="tabpanel"
//                       aria-labelledby="AccountDetails-tab"
//                     >
//                     <DownloadExportData downloadData={downloadData}/>
                
//                       {/* <Uploadphonebook/> */}
//                     </div>

//                     <div
//                       className="tab-pane fade"
//                       id="ContactDetails"
//                       role="tabpanel"
//                       aria-labelledby="ContactDetails-tab"
//                     >
//                       {/* <SubContactDetails /> */}
//                     </div>

//                     <ThemeProvider theme={theme}>
//                       <div
//                         className="tab-pane fade"
//                         id="LoginIPDetails"
//                         role="tabpanel"
//                         aria-labelledby="LoginIPDetails-tab"
//                       >
//                         <form
//                           // onSubmit={formik.handleSubmit}
//                           role="form"
//                           className="text-start mt-5"
//                         >
//                           {/* <!-------------------------group user details--------------------------> */}
//                         </form>

//                         <div className="">{/* <SubLoginIpDetails /> */}</div>

//                         {/* <!-------------------------group user details end----------------------> */}

//                         {/* <!-------------------------group services--------------------------> * */}
//                       </div>
//                     </ThemeProvider>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </main>
//     </>
//   );
// }

// export default withRouter(MainWhitelisting);















import React, { useEffect, useState } from "react";
import TextField from "@mui/material/TextField";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import Navbar from "../Navbar";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";
import FormControl from "@mui/material/FormControl";
import ListItemText from "@mui/material/ListItemText";
import Select from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";
// import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";
import axios from "axios";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Formik, useFormik } from "formik";
import Backdrop from "@mui/material/Backdrop";
import Loader from "../../../components/Loader";
import { createTheme, ThemeProvider } from "@mui/material/styles";
// import ChooseFile from "./ChooseFile";
import { withRouter } from "react-router-dom";
// import Blacklist from "./BlackList";
// import Blacklist from "../Blacklisting/Blacklist";
import Blacklist from "../Blacklisting/Blacklist";
// import Whitelist from "./Whitelist";
import BulkUpload from "../WhiteListing/BulkUpload";
import AddContact from "./AddContact";
import AddNewList from "./AddNewList";
import ImportContact from "./ImportContact";
// import CallIcon from '@mui/icons-material/Call';
import ContactsSharpIcon from "@mui/icons-material/ContactsSharp";
import Swal from "sweetalert2";
import { common_axios } from "../../../App";
import ExportContact2 from "./ExportContact2";
import DownloadExportData from "./DownloadExportData";
// import NumberList from "../WhiteListing/NumberList";
function MainWhitelisting() {
  const theme = createTheme({
    components: {
      MuiInputLabel: {
        styleOverrides: {
          asterisk: { color: "red" },
          // "&$error": {
          //   color: "#db3131",
          // },
        },
      },
    },
  });

  const [MenuItemPhoneBook, setMenuItemPhoneBook] = useState(undefined);
  const callBackFunction1 = (child) => {
    // console.log("child--", child);
    setMenuItemPhoneBook(child);
  };
  const [open, setOpen] = useState();
  const [data, setData] = useState([]);
  // console.log("data--", Namedata);
  const [TableStatus, setTableStatus] = useState({
    hideShow: false,
    pageNo: 0,
    pageSize: 10,
  });
  const [resetValue, setResetValue] = useState(false);
  // ...............................DownloadTab API Redirect................................................//
  const [downloadData, setDownloadData] = useState([]);

  async function DownloadTabApi() {
    setOpen(true);
    try {
      
      // setHideSkeleton(true)
      if (MenuItemPhoneBook == 0) {
        const result = await common_axios.post(
          `${process.env.REACT_APP_COMMON_API_PHONEBOOKCONTACTS}/user/v2/get/phonebook/download/report`,
          // {
          //   pageNo: Status?.pageNo,
          //   pageSize: Status?.pageSize,
          // }

          {
            downloadReportRequest: {
              reportType: "phonebook",
              pageNo: TableStatus?.pageNo,
              pageSize: TableStatus?.pageSize,
            },
          }
        );
        if (result.data.statusdescription.statusCode == 200) {
          // alert("enter")
          // DownloadTabApi()
          setDownloadData(result?.data?.downloadReport);

          setOpen(false);
        } else {
          // setData([])
          setDownloadData([])
          setOpen(false);

          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: result.data.statusdescription.statusDescription,
            // footer: '<a href="">Why do I have this issue?</a>'
          });
        }
      } else {
        setOpen(true);
        const result = await common_axios.post(
          `${process.env.REACT_APP_COMMON_API_PHONEBOOKCONTACTS}/user/v2/get/phonebook/download/report`,
          // {
          //   pageNo: Status?.pageNo,
          //   pageSize: Status?.pageSize,
          // }

          {
            downloadReportRequest: {
              reportType: "Bulk group",
              pageNo: TableStatus?.pageNo,
              pageSize: TableStatus?.pageSize,
            },
          }
        );
        if (result.data.statusdescription.statusCode == 200) {
          // DownloadTabApi()

          setOpen(false);
          setDownloadData(result?.data?.downloadReport);
          // const butt = document.getElementById("Download-tab");
          // butt.click();
        } else {
          // setData([])
          setDownloadData([])
          setOpen(false);

          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: result.data.statusdescription.statusDescription,
            // footer: '<a href="">Why do I have this issue?</a>'
          });
        }
      }
    } catch (error) {
      setOpen(false);
      // toast.error("Please Check Your Network",{
      //   toastId: customId1,
      //   theme: "colored",
      // });
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Check Your Network",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  }

  return (
    <>
      <main className="main-content position-relative border-radius-lg ">
      <div>
          <Backdrop
            sx={{
              color: "#fff",
              zIndex: (theme) => theme.zIndex.drawer + 1,
            }}
            open={open}
          >
            <Loader />
          </Backdrop>
        </div>

        <div className="container-fluid">
          <div className="row">
            <div className="col-xl-12 col-sm-12 mb-xl-0 mb-4">
              <div className="card mb-3">
                <div className="card-header p-3 pt-2">
                  <div className="icon icon-lg icon-shape bg-gradient-primary shadow-primary text-center border-radius-xl mt-n4 position-absolute">
                    <ContactsSharpIcon className="ttl_icon" />
                  </div>
                  <div class="pt-1 marginleft_0">
                    <p class="text-sm mb-0 text-capitalize fw-bold">CONTACT</p>
                    <p className="text-sm mb-0  text d-inline-block float-end">
                      Field(s) marked with{" "}
                      <span className="text-danger fw-bold">*</span> are
                      mandatory.
                    </p>
                  </div>
                  <div className="text-end pt-1">
                    {/* <p className="text-sm mb-0 text-capitalize fw-bold">
                      Account Data Added, Please Provide Sender Masking Details
                      !! Field(s) marked with{" "}
                      <span className="text-danger fw-bold">*</span> are
                      mandatory.
                    </p> */}
                  </div>
                </div>
                <div className="card-body">
                  <ul className="nav nav-tabs" id="myTab" role="tablist">
                    <li className="nav-item  list_1" role="presentation">
                      <button
                        className="nav-link active"
                        id="home-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#AccountDetails"
                        type="button"
                        role="tab"
                        aria-controls="AccountDetails"
                        aria-selected="true"
                        onClick={() => {
                          setResetValue(!resetValue);
                        }}
                      >
                        {/* MSISDN */}
                        {/* Mobile Number */}
                        Add Contact
                      </button>
                    </li>
                    <li className="nav-item  list_1" role="presentation">
                      <button
                        className="nav-link ms-2"
                        id="SenderMasking-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#SenderMasking"
                        type="button"
                        role="tab"
                        aria-controls="SenderMasking"
                        aria-selected="false"
                        // onClick={senderMasking}
                        // disabled
                        onClick={() => {
                          setResetValue(!resetValue);
                        }}
                      >
                        {/* Choose File */}
                        View Contact
                      </button>
                    </li>
                    {/* <li className="nav-item list_1" role="presentation">
                      <button
                        className="nav-link ms-2"
                        id="ContactDetails-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#ContactDetails"
                        type="button"
                        role="tab"
                        aria-controls="ContactDetails"
                        aria-selected="false"
                        onClick={() => {
                          setResetValue(!resetValue);
                        }}
                      >
                        Bulk Upload
                      </button>
                    </li> */}
                    <li className="nav-item  list_1" role="presentation">
                      <button
                        className="nav-link ms-2"
                        id="ExportContact-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#ExportContact"
                        type="button"
                        role="tab"
                        aria-controls="ExportContact"
                        aria-selected="false"
                        // onClick={senderMasking}
                        // disabled
                        onClick={() => {
                          setResetValue(!resetValue);
                        }}
                      >
                        {/* Choose File */}
                        Export Contact
                      </button>
                    </li>
                    <li>
                      <button
                        className="nav-link ms-2 position-relative"
                        id="Download-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#DownloadDetails"
                        type="button"
                        role="tab"
                        aria-controls="DownloadDetails"
                        aria-selected="true"
                        onClick={DownloadTabApi}

                      >
                        Download Report
                      </button>
                    </li>
                  </ul>
                  <div className="tab-content" id="myTabContent">
                    <div
                      className="tab-pane fade show active"
                      id="AccountDetails"
                      role="tabpanel"
                      aria-labelledby="AccountDetails-tab"
                    >
                      <div>
                        <AddContact resetValue={resetValue} />
                      </div>
                    </div>

                    <div
                      className="tab-pane fade"
                      id="SenderMasking"
                      role="tabpanel"
                      aria-labelledby="SenderMasking-tab"
                    >
                      <AddNewList resetValue={resetValue} />{" "}
                    </div>
                    <div
                      className="tab-pane fade "
                      id="ContactDetails"
                      role="tabpanel"
                      aria-labelledby="AccountDetails-tab"
                    >
                      {/* <NumberList /> */}
                      {/* <ImportContact  resetValue={resetValue}/> */}
                    </div>
                    <div
                      className="tab-pane fade "
                      id="ExportContact"
                      role="tabpanel"
                      aria-labelledby="ExportContact-tab"
                    >
                      {/* <ExportContact /> */}
                      <ExportContact2 parentCallback={callBackFunction1}
                      resetValue={resetValue}
                       />
                    </div>
                    <div
                      className="tab-pane fade "
                      id="DownloadDetails"
                      role="tabpanel"
                      aria-labelledby="AccountDetails-tab"
                    >
                      <DownloadExportData downloadData={downloadData} 
                        resetValue={resetValue}
                      />

                      {/* <Uploadphonebook/> */}
                    </div>

                    <div
                      className="tab-pane fade"
                      id="ContactDetails"
                      role="tabpanel"
                      aria-labelledby="ContactDetails-tab"
                    >
                      {/* <SubContactDetails /> */}
                    </div>

                    <ThemeProvider theme={theme}>
                      <div
                        className="tab-pane fade"
                        id="LoginIPDetails"
                        role="tabpanel"
                        aria-labelledby="LoginIPDetails-tab"
                      >
                        <form
                          // onSubmit={formik.handleSubmit}
                          role="form"
                          className="text-start mt-5"
                        >
                          {/* <!-------------------------group user details--------------------------> */}
                        </form>

                        <div className="">{/* <SubLoginIpDetails /> */}</div>

                        {/* <!-------------------------group user details end----------------------> */}

                        {/* <!-------------------------group services--------------------------> * */}
                      </div>
                    </ThemeProvider>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
}

export default withRouter(MainWhitelisting);
